const SLIDE = {

    //===================!!!Slide!!!==========================
    INIT_SLIDE_SETTINGS: 'INIT_SLIDE_SETTINGS',
    UPDATE_SLIDE_SETTINGS: 'UPDATE_SLIDE_SETTINGS',
    CHANGE_SLIDE_NAME: 'CHANGE_SLIDE_NAME',
    CHANGE_SLIDE_BACKGROUND: 'CHANGE_SLIDE_BACKGROUND',
    CHANGE_SLIDE_HAS_BACKGROUND_SHADOW: 'CHANGE_SLIDE_HAS_BACKGROUND_SHADOW',
    CHANGE_SLIDE_BACKGROUND_SHADOW: 'CHANGE_SLIDE_BACKGROUND_SHADOW',
    ERROR_OFF: 'ERROR_OFF',
    
    ADD_CAPTION: 'ADD_CAPTION',
    CHANGE_CAPTION_POSITION: 'CHANGE_CAPTION_POSITION',
    CHANGE_CAPTION_RELATIVE_POSITION: 'CHANGE_CAPTION_RELATIVE_POSITION',
    CHANGE_SOME_CAPTIONS_POSITION: 'CHANGE_SOME_CAPTIONS_POSITION',
    DELETE_CAPTION: 'DELETE_CAPTION',
    DELETE_POINT: 'DELETE_POINT', 
    DELETE_CAPTION_BY_CAPTION_INDEX: 'DELETE_CAPTION_BY_CAPTION_INDEX', 
    APPLY_STYLE: 'APPLY_STYLE', 
    
    ADD_CAPTION_IN_BOX: 'ADD_CAPTION_IN_BOX',
    CHANGE_BOX_POINT_POSITION: 'CHANGE_BOX_POINT_POSITION',
    ADD_POINT: 'ADD_POINT',

    APPLY_CAPTIONS_SIZES_IN_FIRST_LOAD: 'APPLY_CAPTIONS_SIZES_IN_FIRST_LOAD',

    PASTE_CAPTIONS: 'PASTE_CAPTIONS',


    CHANGE_LINK_ON_CLICK: 'CHANGE_LINK_ON_CLICK',
    CHANGE_LINK_TYPE: 'CHANGE_LINK_TYPE',
    CHANGE_LINK: 'CHANGE_LINK',
    CHANGE_IS_HOVER: 'CHANGE_IS_HOVER',

    CHANGE_BORDER_WIDTH: 'CHANGE_BORDER_WIDTH',
    CHANGE_BORDER_RADIUS: 'CHANGE_BORDER_RADIUS',
    CHANGE_BORDER_COLOR: 'CHANGE_BORDER_COLOR',
    CHANGE_BORDER_COLOR_HOVER: 'CHANGE_BORDER_COLOR_HOVER',

    CHANGE_BACKGROUND_COLOR: 'CHANGE_BACKGROUND_COLOR',
    CHANGE_OVERLAY_COLOR: 'CHANGE_OVERLAY_COLOR',
    CHANGE_BACKGROUND_COLOR_HOVER: 'CHANGE_BACKGROUND_COLOR_HOVER',
    CHANGE_PADDING: 'CHANGE_PADDING',

    CHANGE_HOVER_ANIMATION: 'CHANGE_HOVER_ANIMATION',
    CHANGE_ANIMATION_IN: 'CHANGE_ANIMATION_IN',
    CHANGE_ANIMATION_OUT: 'CHANGE_ANIMATION_OUT',

    CHANGE_ANIMATION_IN_MODE: 'CHANGE_ANIMATION_IN_MODE',
    CHANGE_ANIMATION_OUT_MODE: 'CHANGE_ANIMATION_OUT_MODE',
    CHANGE_ANIMATION_DELAY_IN: 'CHANGE_ANIMATION_DELAY_IN',
    CHANGE_ANIMATION_DELAY_OUT: 'CHANGE_ANIMATION_DELAY_OUT',  
    CHANGE_ANIMATION_LOOP: 'CHANGE_ANIMATION_LOOP',  
    
    CHANGE_CAPTION_TEXT: 'CHANGE_CAPTION_TEXT',
    CHANGE_TEXT_ALIGN: 'CHANGE_TEXT_ALIGN',
    CHANGE_CAPTION_FONT: 'CHANGE_CAPTION_FONT',
    CHANGE_CAPTION_FONT_COLOR: 'CHANGE_CAPTION_FONT_COLOR',
    CHANGE_CAPTION_FONT_COLOR_HOVER: 'CHANGE_CAPTION_FONT_COLOR_HOVER',
    CHANGE_CAPTION_FONT_SIZE: 'CHANGE_CAPTION_FONT_SIZE',
    CHANGE_CAPTION_LINE_HEIGHT: 'CHANGE_CAPTION_LINE_HEIGHT',
    CHANGE_CAPTION_ITALIC: 'CHANGE_CAPTION_ITALIC',
    CHANGE_CAPTION_BOLD: 'CHANGE_CAPTION_BOLD',
    CHANGE_CAPTION_UNDERLINE: 'CHANGE_CAPTION_UNDERLINE',
    CHANGE_CAPTION_STRIKETHROUGH: 'CHANGE_CAPTION_STRIKETHROUGH',
    CHANGE_CAPTION_SHADOW: 'CHANGE_CAPTION_SHADOW',
    CHANGE_CAPTION_HAS_SHADOW: 'CHANGE_CAPTION_HAS_SHADOW',
    CHANGE_BUTTON_TEXT_HAS_SHADOW: 'CHANGE_BUTTON_TEXT_HAS_SHADOW',
    CHANGE_BUTTON_TEXT_SHADOW: 'CHANGE_BUTTON_TEXT_SHADOW',
    ROTATE_CAPTION: 'ROTATE_CAPTION',
    CHANGE_CAPTION_LETTER_SPACING: 'CHANGE_CAPTION_LETTER_SPACING',
    CHANGE_LETTER_CASE: 'CHANGE_LETTER_CASE',
    TOGGLE_SEPARATE_CORNERS: 'TOGGLE_SEPARATE_CORNERS',

    CHANGE_CAPTION_DIMESIONS: 'CHANGE_CAPTION_DIMESIONS',
    CHANGE_BOX_EDITING_DIMANSIONS: 'CHANGE_BOX_EDITING_DIMANSIONS',
    CHANGE_CAPTION_MOBILE_SHOW: 'CHANGE_CAPTION_MOBILE_SHOW',
    TOGGLE_CAPTION_HIDE: 'TOGGLE_CAPTION_HIDE',
    SET_CAPTION_SIZE: 'SET_CAPTION_SIZE',
    CHANGE_ARRAY_CAPTIONS_DIMESIONS: 'CHANGE_ARRAY_CAPTIONS_DIMESIONS',


    ADD_ACTION: 'ADD_ACTION',
    CLEAR_ACTIONS_HISTORY: 'CLEAR_ACTIONS_HISTORY',
    UNDO: 'UNDO',
    REDO: 'REDO',

    CHANGE_CAPTION_ORDER: 'CHANGE_CAPTION_ORDER',
    CHANGE_LAYER: 'CHANGE_LAYER',

    CHANGE_CAPTION_ALIGN: 'CHANGE_CAPTION_ALIGN',

    CAPTIONS_DISTRIBUTE_VERTICALLY: 'CAPTIONS_DISTRIBUTE_VERTICALLY',
    CAPTIONS_DISTRIBUTE_HORIZONTALLY: 'CAPTIONS_DISTRIBUTE_HORIZONTALLY',
    CAPTIONS_DISTRIBUTE: 'CAPTIONS_DISTRIBUTE',
    CONVERT_BOX_POINT_POSITION: 'CONVERT_BOX_POINT_POSITION',
    
    TOGGLE_RTL: 'TOGGLE_RTL',



    //TYPING ANIMATION 
    CHANGE_PAUSE_BETWEEN_LINES: 'CHANGE_PAUSE_BETWEEN_LINES',
    ADD_LINE: 'ADD_LINE',
    CHANGE_LINE_TEXT: 'CHANGE_LINE_TEXT',
    DELETE_LINE: 'DELETE_LINE',
    CHANGE_SELECTED_LINE: 'CHANGE_SELECTED_LINE',
    
    // parallax
    TOGGLE_PARALLAX: 'TOGGLE_PARALLAX',
    CHANGE_PARALLAX_IMAGE: 'CHANGE_PARALLAX_IMAGE',
    APPLY_PARALLAX_CROP: 'APPLY_PARALLAX_CROP',
    


    DELETE_TOAST: 'DELETE_TOAST',
    CHANGE_CAPTION_SHAPE: 'CHANGE_CAPTION_SHAPE',
    CHANGE_HTML_TAG: 'CHANGE_HTML_TAG',

    TOGGLE_BUTTON_ICON: 'TOGGLE_BUTTON_ICON',
    CHANGE_BUTTON_ICON_MARGIN: 'CHANGE_BUTTON_ICON_MARGIN',
    CHANGE_BUTTON_ICON: 'CHANGE_BUTTON_ICON',
    CHANGE_BUTTON_ICON_LOCATION: 'CHANGE_BUTTON_ICON_LOCATION',
    CHANGE_BUTTON_ICON_SIZE: 'CHANGE_BUTTON_ICON_SIZE',
    CHANGE_BUTTON_ICON_ANIMATION: 'CHANGE_BUTTON_ICON_ANIMATION',
    TOGGLE_BUTTON_ANIMATION: 'TOGGLE_BUTTON_ANIMATION',
    TOGGLE_BUTTON_ICON_ANIMATION: 'TOGGLE_BUTTON_ICON_ANIMATION',
    SET_TEXT_STROKE_SIZE: 'SET_TEXT_STROKE_SIZE',
    SET_TEXT_STROKE_COLOR: 'SET_TEXT_STROKE_COLOR',
    SET_BLUR: 'SET_BLUR',
    TOGGLE_GLASS_BLUR: 'TOGGLE_GLASS_BLUR',
    CHANGE_SVG_SRC: 'CHANGE_SVG_SRC',
    SET_IMAGE_CAPTION_CROP: 'SET_IMAGE_CAPTION_CROP',
    CAPTION_IMAGE_CHANGE: 'CAPTION_IMAGE_CHANGE',
    CHANGE_CAPTION_STRIPES_COLOR: 'CHANGE_CAPTION_STRIPES_COLOR',
    CHANGE_CAPTION_STRIPES_SPEED: 'CHANGE_CAPTION_STRIPES_SPEED',
    CHANGE_CAPTION_TYPEWRITER_CURSOR: 'CHANGE_CAPTION_TYPEWRITER_CURSOR',
    CHANGE_CAPTION_SEO_TEXT: 'CHANGE_CAPTION_SEO_TEXT',
    CHANGE_CAPTION_EFFECT: 'CHANGE_CAPTION_EFFECT',
    SET_INVERT_EFFECT: 'SET_INVERT_EFFECT',
    SET_GRAYSCALE_EFFECT: 'SET_GRAYSCALE_EFFECT',
    SET_GLASS_EFFECT: 'SET_GLASS_EFFECT',
    CHANGE_CAPTION_CUBE_HEIGHT: 'CHANGE_CAPTION_CUBE_HEIGHT',
    HIDE_SHOW_CAPTIONS_OUTSIDE: 'HIDE_SHOW_CAPTIONS_OUTSIDE',
    
}

export { SLIDE }